import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import './CustomDialog.scss';

interface IProps {
  open: boolean;
  children: React.ReactElement;
  title: string;
  actions?: React.ReactElement;
  titleActions?: React.ReactElement;
  handleClose: () => void;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onTransitionEnd?: () => void;
}

export const CustomDialog: React.FC<IProps> = ({ open, children, title, actions, titleActions, handleClose, maxWidth = 'xs', className, onTransitionEnd }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      className={`psf-dialog ${className || ''}`}
      disableRestoreFocus={false}
      slotProps={{
        transition: {
          onEntered: onTransitionEnd,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" className="psf-dialog__header">
        <Box>
          <IconButton onClick={handleClose} className="psf-dialog__close-btn">
            <CloseIcon fontSize="medium" sx={{ color: '#000' }} />
          </IconButton>
        </Box>
        <Box className="psf-dialog__title">{title}</Box>
        {titleActions && <Box className="psf-dialog__title-actions">{titleActions}</Box>}
      </DialogTitle>
      <DialogContent className="psf-dialog__content">{children}</DialogContent>
      {actions && <DialogActions className="psf-dialog__actions">{actions}</DialogActions>}
    </Dialog>
  );
};
